import Forms from "./Forms";
import React from "react";

const AddressesEditor = ({items = [], onChange}) => {
    const update = (i, patch) => {
        const copy = [...items];
        copy[i] = {...copy[i], ...patch};
        onChange(copy);
    };
    const remove = (i) => onChange(items.filter((_, idx) => idx !== i));
    const setDefault = (i) => onChange(items.map((a, idx) => ({...a, isDefault: idx === i})));

    return (
        <div className="space-y-3">
            {items.map((a, i) => (
                <div key={i} className="p-3 border rounded-lg">
                    <div className="grid grid-cols-1 md:grid-cols-6 gap-3 items-end">
                        <Forms.Select
                            label="Typ"
                            value={a.type || 'other'}
                            onChange={v => update(i, {type: v})}
                            options={[
                                {value: 'billing', label: 'Fakturační'},
                                {value: 'shipping', label: 'Doručovací'},
                                {value: 'other', label: 'Jiná'}
                            ]}
                        />
                        <Forms.Text label="Štítek" value={a.label || ''} onChange={v => update(i, {label: v})}/>
                        <Forms.Text label="Firma (na doklad)" value={a.company || ''}
                                    onChange={v => update(i, {company: v})}/>
                        <Forms.Text label="Jméno příjemce" value={a.name || ''} onChange={v => update(i, {name: v})}/>
                        <Forms.Checkbox label="Výchozí" checked={!!a.isDefault} onChange={() => setDefault(i)}/>
                        {items.length > 1 &&
                            <Forms.Button type="button" variant="danger" label="–" onClick={() => remove(i)}/>}
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-5 gap-3 mt-3">
                        <Forms.Text label="Ulice" value={a.street || ''}
                                    onChange={v => update(i, {street: v})}/>
                        <Forms.Text label="Číslo popisné" value={a.houseNumber || ''}
                                    onChange={v => update(i, {houseNumber: v})}/>
                        <Forms.Text label="Město" value={a.city || ''} onChange={v => update(i, {city: v})}/>
                        <Forms.Text label="Kraj/Region" value={a.region || ''} onChange={v => update(i, {region: v})}/>
                        <Forms.Text label="PSČ" value={a.zip || ''} onChange={v => update(i, {zip: v})}/>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mt-3">
                        <Forms.Text label="Stát (ISO)" value={a.countryCode || 'CZ'}
                                    onChange={v => update(i, {countryCode: v})}/>
                        <Forms.Text label="Poznámka" value={a.note || ''} onChange={v => update(i, {note: v})}/>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default AddressesEditor;